import React, { useEffect, useRef, useState, memo, useCallback } from 'react';

const CountUp = memo(({ start = 0, end, duration = 1200, prefix = '', suffix = '', decimals = 0 }) => {
  const [value, setValue] = useState(start);
  const startTimestamp = useRef(null);
  const rafId = useRef(null);

  const animateCountUp = useCallback((timestamp) => {
    if (!startTimestamp.current) startTimestamp.current = timestamp;
    const progress = Math.min((timestamp - startTimestamp.current) / duration, 1);
    const current = start + (end - start) * progress;
    setValue(current);
    if (progress < 1) {
      rafId.current = requestAnimationFrame(animateCountUp);
    } else {
      setValue(end);
    }
  }, [start, end, duration]);

  useEffect(() => {
    setValue(start);
    rafId.current = requestAnimationFrame(animateCountUp);
    return () => {
      if (rafId.current) {
        cancelAnimationFrame(rafId.current);
      }
    };
  }, [animateCountUp]);

  const displayValue = decimals > 0 ? value.toFixed(decimals) : Math.round(value);

  return (
    <span>
      {prefix}{displayValue}{suffix}
    </span>
  );
});

CountUp.displayName = 'CountUp';

export default CountUp; 